<template>
  <!-- Table Container Card -->
  <b-card no-body>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Entry -->
        <b-col
          cols="12"
          md="9"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('globalActions.find')"
            />
          </div>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="3"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <b-button
            variant="primary"
            :to="{ name: 'apps-master-data-coa-add'}"
          >
            <feather-icon icon="PlusIcon" /> {{ $t('apps.masterDataCOA.actions.create') }}
          </b-button>
        </b-col>
      </b-row>
    </div>

    <b-table
      id="refListTable"
      ref="refListTable"
      no-provider-paging
      no-provider-filtering
      :filter-included-fields="columnToBeFilter"
      :fields="tableColumns"
      :items="itemLists"
      :per-page="perPage"
      :current-page="currentPage"
      :filter="searchQuery"
      responsive
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      :busy="isBusy"
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
    >

      <template #table-busy>
        <div class="text-center text-primary my-2 d-flex flex-column justify-content-center">
          <div class="text mb-1">
            <b-spinner class="align-middle" />
          </div>
          <strong>{{ $t('globalActions.fetchingDataAPI') }}</strong>
        </div>
      </template>

      <!-- Column: code -->
      <template #cell(code)="data">
        <b-link
          v-if="data.item.is_account_parent || Number(data.item.account_level) === 1"
          :to="{ name: 'apps-master-data-coa-detail', params: { id: data.item.id }}"
          class="d-block, text-nowrap, font-weight-bolder"
          :style="setPadding(data.item)"
        >
          {{ data.item.account_number }} - {{ data.item.account_name }}
        </b-link>

        <b-link
          v-else
          :to="{ name: 'apps-master-data-coa-detail', params: { id: data.item.id }}"
          class="d-block, text-nowrap"
          :style="setPadding(data.item)"
        >
          {{ data.item.account_number }} - {{ data.item.account_name }}
        </b-link>
      </template>

      <!-- Column: code -->
      <template #cell(code_default)="data">
          {{ data.item.account_name_default }}
      </template>

            <!-- Column: code -->
      <template #cell(account_description)="data">
        <span v-if="data.item.is_account_parent === false" class="font-weight-bold d-block text-nowrap">
        <div v-if="data.item.account_description !== '' ">
          {{ data.item.account_description }} 
        </div>
        <div v-else>
          -
        </div>
        </span>
      </template>

            <!-- Column: Account Subype -->
      <template #cell(accountTypes)="data">
        <span v-if="data.item.is_account_parent === false" class="font-weight-bold d-block text-nowrap">
          {{ data.value.type_name }}
        </span>
      </template>

      <!-- Column: Account Subype -->
      <template #cell(accountSubtypes)="data">
        <span v-if="data.item.is_account_parent === false" class="font-weight-bold d-block text-nowrap">
          {{ data.value.subtype_name }}
        </span>
      </template>

      <!-- Column: Normal Balance -->
      <template #cell(normalBalance)="data">
        <span v-if="data.item.is_account_parent === false && data.item.normal_balance === 'DB'" class="font-weight-bold d-block text-nowrap">
           Debit
        </span>
        <span v-if="data.item.is_account_parent === false && data.item.normal_balance === 'CR'" class="font-weight-bold d-block text-nowrap">
           Credit
        </span>
      </template>
    </b-table>

    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalList"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            aria-controls="refInvoiceListTable"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>

  </b-card>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BLink,
  BPagination,
  BSpinner
} from 'bootstrap-vue'

import { onMounted } from '@vue/composition-api'
// import useList from './useList'
import useListTable from '@/comp-functions/useListTable'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BPagination,
    BSpinner
  },
  setup () {
    // Table Handlers
    const tableColumns = [
      { key: 'code', label: 'Account Name', sortable: true },
      { key: 'code_default', label: 'Account Name Default', sortable: true },
      { key: 'account_description', label: 'Description', sortable: true },
      { key: 'accountTypes', label: 'Accounts Types', sortable: true },
      { key: 'accountSubtypes', label: 'Account Subtype' },
      { key: 'normalBalance', label: 'Normal Balance' }
    ]
    
    // Table Handlers
    const columnToBeFilter = [
      'account_number',
      'account_name',
      'account_subtype_code'
    ]

    const setPadding = (row) => {
      return `padding-left: ${(row.account_level - 1) * 30}px;`
    }

    const {
      isBusy,
      itemLists,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      statusFilter,
      changePerPage
    } = useListTable({ url: 'master/accounts' })

    // console.log(itemLists)

    onMounted(() => {
      changePerPage(30)
    })

    return {
      tableColumns,
      columnToBeFilter,
      setPadding,
      isBusy,
      itemLists,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      statusFilter,
      changePerPage
    }
  }
}
</script>
